var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.showUrl ? _c('div', {
    staticClass: "mb-6"
  }, [_c('a', {
    on: {
      "click": function ($event) {
        return _vm.copyToClipboard(_vm.url);
      }
    }
  }, [_vm._v(_vm._s(_vm.url))])]) : _vm._e(), _c('div', {
    staticClass: "btn-group"
  }, [_c('tooltip-btn', {
    attrs: {
      "msg": "Copy link to clipboard",
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var on = _ref.on;
        return [_c('v-btn', _vm._g({
          directives: [{
            name: "blur",
            rawName: "v-blur"
          }],
          staticClass: "btn-group-right px-3",
          attrs: {
            "disabled": _vm._disabled
          },
          on: {
            "click": function ($event) {
              return _vm.copyToClipboard(_vm.url);
            }
          }
        }, on), [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiClipboardArrowUp)
          }
        })], 1)];
      }
    }])
  }), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _c('tooltip-btn', {
    attrs: {
      "msg": "Share link via email",
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref2) {
        var on = _ref2.on;
        return [_c('v-btn', _vm._g({
          directives: [{
            name: "href-fallback",
            rawName: "v-href-fallback"
          }],
          staticClass: "btn-group-left px-3",
          class: {
            'btn-group-right': _vm.IS_MOBILE
          },
          attrs: {
            "href": _vm.email,
            "disabled": _vm._disabled
          }
        }, on), [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiEmail)
          }
        })], 1)];
      }
    }])
  }), _vm.IS_MOBILE ? [_c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _c('tooltip-btn', {
    attrs: {
      "msg": "Share link via text message",
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref3) {
        var on = _ref3.on;
        return [_c('v-btn', _vm._g({
          directives: [{
            name: "href-fallback",
            rawName: "v-href-fallback"
          }],
          staticClass: "btn-group-left px-3",
          attrs: {
            "href": _vm.text,
            "disabled": _vm._disabled
          }
        }, on), [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiMessage)
          }
        })], 1)];
      }
    }], null, false, 3849696686)
  })] : _vm._e()], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }